// extracted by mini-css-extract-plugin
export default {"home":"index_home__wZO91","content":"index_content__V1mBe","top":"index_top__-WmFn","table":"index_table__1kr27"};